export default __webpack_public_path__ + "static/media/icon-build-land.403bbab7.svg";